import { isEmpty } from 'es-toolkit/compat';
import { curry } from 'es-toolkit';

export function emptyObjectToUndefined<T extends object>(
  obj: T,
): T | undefined {
  return isEmpty(obj) ? undefined : obj;
}

type NonEmpty<T> = T extends {} ? (keyof T extends never ? never : T) : T;

export const undefinedOrTransformToDTO = <T extends object, U>(
  transform: (obj: NonEmpty<T>) => U,
  obj: T,
): U | undefined => {
  return isEmpty(obj) ? undefined : transform(obj as NonEmpty<T>);
};

export const undefinedOrTransformToDTOCurried = curry(
  undefinedOrTransformToDTO,
);
